import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import Image from "gatsby-plugin-sanity-image"

const SmallNewsBox = ({
  themeColor,
  title,
  categoryLink,
  subcategory,
  category,
  link,
  image,
}) => {
  // var themeBgColor = "text-fb-blue"

  // switch (themeColor) {
  //   case "fb-green": {
  //     themeBgColor = "bg-fb-green"
  //     break
  //   }
  //   case "fb-turquoise": {
  //     themeBgColor = "bg-fb-turquoise"
  //     break
  //   }
  //   case "fb-gray": {
  //     themeBgColor = "bg-fb-gray"
  //     break
  //   }
  //   case "fb-red": {
  //     themeBgColor = "bg-fb-red"
  //     break
  //   }
  //   case "fb-violet": {
  //     themeBgColor = "bg-fb-violet"
  //     break
  //   }
  //   default: {
  //     themeBgColor = "bg-fb-blue"
  //     break
  //   }
  // }
  return (
    <>
      <div className="relative h-80 mb-5">
        <Link to={`/${categoryLink}/${link}`}>
          <Image
            // pass asset, hotspot, and crop fields
            {...image}
            // tell Sanity how large to make the image (does not set any CSS)
            width={300}
            height={300}
            alt={image.alt || "Finanzas de Bolsillo"}
            className="rounded-t"
            // style it how you want it
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Link>

        {/* <div className={`${themeBgColor} p-3 absolute top-0 w-full`}>
          <p className="font-opensanscond text-2xl font-semibold text-yellow-200 truncate">
            {subcategory}
          </p>
          <Link to={`/${categoryLink}/${link}`} className="link text-gray-100">
            <p className="text-gray-100 font-opensanscond font-normal text-lg truncate">
              {title}
            </p>
          </Link>
        </div> */}
        <Link to={`/${categoryLink}/${link}`} className="link text-gray-100">
          <div className="bg-fb-blue bg-opacity-90 p-3 absolute bottom-5 w-full">
            <p className="font-opensanscond text-xl md:text-2xl font-semibold text-yellow-200">
              {title}
            </p>

            <p className="text-gray-100 pt-5 font-opensanscond font-bold px-5 text-3xl">
              {category}
            </p>
          </div>
        </Link>
      </div>
    </>
  )
}

SmallNewsBox.prototype = {
  mainPicture: PropTypes.string,
  themeColor: PropTypes.string,
}
SmallNewsBox.defaultProps = {
  mainPicture: `https://source.unsplash.com/random`,
  themeColor: `fb-blue`,
}

export default SmallNewsBox
